// 会议记录 默认最多展示的条数
export const DEFAULT_MAX_SHOW_OF_MEETINGS = 5;
